import { apiService } from '@/lib/api';
import { AttachmentsModal } from '@/components/AttachmentsModal';

interface JobAttachmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  jobId: string;
  onAttachmentsUpdated: () => void;
  /** Opened from the invoice: new uploads are added to the invoice PDF. */
  uploadsIncludedInPdf?: boolean;
}

export function JobAttachmentsModal({ isOpen, onClose, jobId, onAttachmentsUpdated, uploadsIncludedInPdf }: JobAttachmentsModalProps) {
  return (
    <AttachmentsModal
      isOpen={isOpen}
      onClose={onClose}
      ownerId={jobId}
      title="Job Attachments"
      queryKey="jobAttachments"
      onAttachmentsUpdated={onAttachmentsUpdated}
      fetchAttachments={apiService.getJobAttachments.bind(apiService)}
      prepareUpload={apiService.prepareAttachmentUpload.bind(apiService)}
      completeUpload={apiService.completeAttachmentUpload.bind(apiService)}
      getDownloadUrl={apiService.getAttachmentDownloadUrl.bind(apiService)}
      updateAttachment={apiService.updateJobAttachment.bind(apiService)}
      deleteAttachment={apiService.deleteJobAttachment.bind(apiService)}
      pdf={{
        document: 'invoice',
        setIncluded: (id, attachmentId, included) => apiService.updateJobAttachment(id, attachmentId, { include_in_pdf: included }),
        uploadsIncluded: uploadsIncludedInPdf,
      }}
    />
  );
}
